import firebase from "firebase/app";
import "firebase/firestore";

import { Log } from "features/shared/types/info";
import { AppThunk } from "services/redux/rootReducer";

const addOneLog =
    (log: Log): AppThunk =>
    async (_dispatch, getState) => {
        const creationTimestamp = log.creationTimestamp || Date.now();
        const uid = log.userInfo?.uid || getState().auth.uid;

        const db = firebase.firestore();
        const docRef = db.collection("logs").doc(creationTimestamp.toString());
        await docRef.set({
            ...log,
            creationTimestamp,
            userInfo: {
                uid,
            },
        });
        return;
    };

export default addOneLog;
